import { create } from 'zustand';

export type ToastTone = 'neutral' | 'success' | 'danger';

export interface ToastAction {
  /** Etykieta — już przetłumaczona. */
  label: string;
  onAction: () => void;
}

export interface Toast {
  id: string;
  /** Treść — już przetłumaczona. Komponenty `shared/ui` nie tłumaczą za wołającego. */
  message: string;
  tone: ToastToneOrDefault;
  action?: ToastAction | undefined;
  /**
   * Czas życia. Domyślnie 6 s, ale komunikat z akcją „Cofnij" dostaje więcej —
   * cofnięcie, którego nie da się kliknąć, bo znikło, jest gorsze niż jego brak.
   */
  durationMs: number;
}

type ToastToneOrDefault = ToastTone;

interface ToastState {
  toasts: Toast[];
  show: (toast: Omit<Toast, 'id' | 'tone' | 'durationMs'> & {
    tone?: ToastTone;
    durationMs?: number;
  }) => string;
  dismiss: (id: string) => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],

  show: ({ message, action, tone = 'neutral', durationMs }) => {
    const id = globalThis.crypto.randomUUID();

    set((state) => ({
      toasts: [
        ...state.toasts,
        {
          id,
          message,
          tone,
          action,
          durationMs: durationMs ?? (action ? 10_000 : 6_000),
        },
      ],
    }));

    return id;
  },

  dismiss: (id) =>
    set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) })),
}));

/** Skrót pod najczęstszy przypadek z sek. 4B: zapis optimistic + możliwość cofnięcia. */
export function showUndoToast(message: string, undoLabel: string, onUndo: () => void): string {
  return useToastStore.getState().show({
    message,
    action: { label: undoLabel, onAction: onUndo },
  });
}
